module.exports = __webpack_public_path__ + "img/t3.822dfcb4.png";